import { AppService } from './app.service';
import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit  {

  financeApi: any;
  noSession: boolean;

  constructor(
    private appService: AppService,
    private translate: TranslateService) {
      translate.setDefaultLang('de');
      translate.use('de');
  }

  ngOnInit(): void {
    this.financeApi = this.appService.getInstance();
    if (!this.financeApi) {
      this.noSession = true;
      console.log('No Session');
    } else {
      this.noSession = false;
    }
  }

}
